import React from "react";
import ContentButton from "../core/ui/ContentButton";

interface SpotlightSectionProps {
  id?: string;
  eyebrow: React.ReactNode;
  heading: React.ReactNode;
  intro?: React.ReactNode;
  bullets: React.ReactNode[];
  linkLabel: string;
  linkHref: string;
}

const SpotlightSection: React.FC<SpotlightSectionProps> = ({
  id,
  eyebrow,
  heading,
  intro,
  bullets,
  linkLabel,
  linkHref,
}) => {
  const linkIsExternal = /^https?:/.test(linkHref);
  return (
    <section id={id} className="cs-section cs-spotlight">
      <div className="cs-spotlight-inner">
        <div className="eyebrow">{eyebrow}</div>
        <h2>{heading}</h2>
        {intro && <p className="cs-spotlight-intro">{intro}</p>}
        <ul className="cs-spotlight-list">
          {bullets.map((bullet, index) => (
            <li key={`spotlight-bullet-${index + 1}`}>{bullet}</li>
          ))}
        </ul>
        <ContentButton
          href={linkHref}
          variant="secondary"
          target={linkIsExternal ? "_blank" : undefined}
          rel={linkIsExternal ? "noopener noreferrer" : undefined}
        >
          {linkLabel}
        </ContentButton>
      </div>
    </section>
  );
};

export default SpotlightSection;
